import owd from 'owd/owd';

export default class FullscreenPlayer extends owd.Component {
	init() {
		this.zIndexOverall = 10000000000;
		this.zIndexDefault = 5;
        this.isOpened = false;
        this.$mainContainer = $('.main-container');
		this.$exitButton = this.$element.find('[data-fullscreen-exit]');
		this.$players = this.$element.find('[data-fs-player]');
		this.$videos = this.$element.find('video');
		this.$html = $('html');

		this.swiper = this.$element.find('[data-slider-fullscreen]').data('swiperInstance');

		this.$videos;

		this.bind();
	}

	loadVideos() {
		this.$element.find([
			'.swiper-slide-active',
			'.swiper-slide-prev',
			'.swiper-slide-next',
			'.swiper-slide-duplicate-active',
			'.swiper-slide-duplicate-prev',
			'.swiper-slide-duplicate-next'
		].join(',')).find('[data-video]').each((i, obj) => {
			if ($(obj).data('videoApi')) {
				//$(obj).data('videoApi').load();
			}
		});
	}

	stopVideos() {
		this.$videos.each((i, obj) => {
			let video = $(obj)[0];

			video.pause();
			video.currentTime = 0;
		})

		this.$players.removeClass('is-playing');
	}

	closeModal() {
		this.dom.$window.trigger('close-fs-modal');
		this.isOpened = false;
		this.$element.removeClass('is-visible');
		this.$players.removeClass('has-nav-hidden');
		this.$mainContainer.css({
			zIndex: this.zIndexDefault,
			backgroundColor: 'rgba(0,0,0, 0)'
		});

		this.$html.removeClass('hide-scroll');

		this.stopVideos();
	}

	bind() {
		// let $swiper = this.$element.find('[data-slider-fullscreen]');

        this.on('click', this.dom.$body, '[data-fullscreen-button]', (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.$element.addClass('is-visible');
			this.isOpened = true;
			this.$html.addClass('hide-scroll');
			this.$mainContainer.css({
				zIndex: this.zIndexOverall,
				backgroundColor: 'rgba(0,0,0,1)'
			});

			const slideSlug = $(e.currentTarget).data('fullscreen-button');
			const $slide = this.$element.find('[data-slider-fullscreen] .slide[data-slug="' + slideSlug + '"]');
			const type = $slide.data('type');


			if (type == 'video') {
				const title = $slide.data('title');
				const permalink = $slide.data('permalink');


				if (window.matchMedia('(min-width: 520px)').matches) {
					$('.fullscreen--info-title').show();
				}

				$('.fullscreen--info-title').html(title);

				if (permalink) {
					$('.fullscreen--info-project').show();
					$('.fullscreen--info-project').attr('href', permalink);
				} else {
					$('.fullscreen--info-project').hide();
				}
			} else {
				$('.fullscreen--info-title').html("&nbsp;");
				$('.fullscreen--info-project').hide();
			}

			const slideNum = $slide.data('slide-number');

			this.swiper.update();
			this.swiper.slideToLoop(slideNum, 0);

			// console.log(this.swiper);

			let $video = $(this.swiper.slides[this.swiper.activeIndex]).find('[data-fs-player-video]');
			let $fSPlayer = $video.closest('[data-fs-player]');

			console.log(slideSlug, $slide[0], slideNum, this.swiper.activeIndex);
if($video.length>0) {
			$video.data('videoApi').play();
		}
			$fSPlayer.trigger('fs-state-play');
			$fSPlayer.addClass('is-playing');

			setTimeout(() => {
				this.loadVideos();
			});

			this.$mainContainer.css({
				zIndex: this.zIndexOverall,
				backgroundColor: 'rgba(0,0,0, 1)'
			});
		});

		this.on('slideChange', this.swiper, () => {
			const $slide = $(this.swiper.slides[this.swiper.activeIndex]);

			const type = $slide.data('type');
			this.stopVideos();

			if (type == 'video') {
				const title = $slide.data('title');
				const permalink = $slide.data('permalink');

				if (window.matchMedia('(min-width: 520px)').matches) {
					$('.fullscreen--info-title').show();
				}

				$('.fullscreen--info-title').html(title);

				if (permalink) {
					$('.fullscreen--info-project').show();
					$('.fullscreen--info-project').attr('href', permalink);
				} else {
					$('.fullscreen--info-project').hide();
				}
			} else {
				$('.fullscreen--info-title').html("&nbsp;");
				$('.fullscreen--info-project').hide();
			}

			setTimeout(() => {
				this.loadVideos();
			});


		});

		this.on('slideChangeTransitionEnd', this.swiper, () => {
			this.loadVideos();
		});

		this.on('slider-updated', this.dom.$window, () => {
			this.loadVideos();
        });

		this.on('click touchstart', this.$exitButton, (e) => {
			e.stopPropagation();
			e.preventDefault();
			
			this.closeModal();
		});
		
		this.on('click touchstart', '[download]', () => {
			this.stopVideos();
        });

		this.on('keydown', this.dom.$window, (e) => {
			if (e.keyCode === 27 && this.isOpened) {
				this.closeModal();
			}
		})

		if ($('.fullscreen--info-project').length) {
			this.on('click touchstart', $('.fullscreen--info-project'), () => {
				this.$html.removeClass('hide-scroll');
			});
		}
	}
}

owd.registerComponent('fullscreen-player', {
	component: FullscreenPlayer
});
